<template>
  <el-dialog :visible.sync="isOpen" width="7.2rem" append-to-body :close-on-click-modal="false" destroy-on-close
    custom-class="extract-dialog">
    <div slot="title" class="my-header">
      {{ type == '1' ? 'Extract Tcash' : 'Extract UNIT' }}
    </div>
    <div>
      <div class="spaceLeft">
        <div class="detail-title-2">No. {{ pageData.number }}</div>
        <div class="status" :class="{ 'status-ing': pageData.status != 3, 'status-over': isOver(pageData.overtime) }">
          {{ statusMap["status_" + (isOver(pageData.overtime) ? "3" : pageData.status)] }}</div>
      </div>
      <div>
        <div class="detail-item spaceLeft">
          <span class="detail-item-label">Start time:</span>
          <span>{{ moment(pageData.timestamp).format("YYYY-MM-DD HH:mm:ss") }}</span>
          </div>
          <div class="detail-item spaceLeft">
          <span class="detail-item-label">Closing time:
            {{ moment(pageData.overtime).format("YYYY-MM-DD HH:mm:ss") }}</span>
        </div>
        <template v-if="type == '1'">
          <div class="detail-item spaceLeft">
            <span class="detail-item-label">Auction:</span>
            <span><big-number :number="pageData.amount" /></span><span class="unit">UNIT</span>
          </div>
          <div class="detail-item spaceLeft">
            <span class="detail-item-label">My bid pric :</span>
            <span class="big-num">
              <big-number
                :number="pageData.auctiondetail && pageData.auctiondetail[0] && pageData.auctiondetail[0].amount" />
            </span><span class="unit">TCash</span>
          </div>
        </template>
        <div class="detail-item spaceLeft" v-if="type == '2'">
          <span class="detail-item-label">Auction :</span>
          <span class="big-num">
            <big-number :number="pageData.amount" />
          </span><span class="unit">UNIT</span>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">Cancel</el-button>
      <loading-btn type="primary" label="Extract" @clickHandle="save" />
    </span>
  </el-dialog>
</template>

<script>
import { deepClone } from "@/utils/index.js";
import { getContractTCashAuction } from "@/api/contract.js";
import { toBigNum } from "@/utils/bigNumberTran.js";
export default {
  data() {
    return {
      type: "1",
      isOpen: false,
      pageData: {},
      statusMap: this.$store.getters.auctionStatusMap
    };
  },
  computed: {},
  methods: {
    open({ type, row } = {}) {
      this.type = type;
      this.isOpen = true;
      this.pageData = deepClone(row);
      this.init();
      console.log(this.pageData)
    },
    close() {
      this.isOpen = false;
      this.pageData = {};
    },
    async init() {
      // let res = await getContractTCashAuction();
      // console.log('res', res);
      // let resData = res.result;
      // this.contractTCashAuction = new web3.eth.Contract(
      //   resData.abi,
      //   resData.address
      // );
      let res = this.$store.getters.contractMap['contractTCashAuction'];
      this.contractTCashAuctionAddress = res.address;
      this.contractTCashAuction = res.contract;
    },
    save(btn) {
      let methodName = this.type == 1 ? "bidWithdrawal" : "getAuction";
      console.log('methodName', methodName);
      // let amount = 0;
      // if(this.type == 1){
      //   amount = this.pageData.auctiondetail&&this.pageData.auctiondetail[0]&&this.pageData.auctiondetail[0].amount;
      // }else{
      //   this.pageData.amount;
      // }
      const tx_builder = this.contractTCashAuction.methods[methodName](
        this.pageData.number
      );
      const encoded_tx = tx_builder.encodeABI();
      web3.eth
        .sendTransaction({
          gas: this.$store.getters.gas,
          from: this.$store.getters.metaMaskObj.account,
          to: this.contractTCashAuctionAddress,
          value: 0,
          data: encoded_tx
        })
        .then(res => {
          setTimeout(() => {
            btn.closeLoad();
            this.close();
            this.$emit("refresh");
          }, 3000)
          this.$message.success("operation successful!");
        })
        .catch(error => {
          // 获取更详细的错误信息
          console.error("Transaction Error:", error);

          // 尝试从错误对象中提取更详细的信息
          let errorMessage = "operation failed";
          if (error.message) {
            errorMessage += ": " + error.message;
          }

          // 如果有交易哈希，尝试获取交易回执以获取更多详情
          if (error.transactionHash) {
            web3.eth.getTransactionReceipt(error.transactionHash)
              .then(receipt => {
                console.log("Transaction Receipt:", receipt);
                if (receipt && receipt.status === false) {
                  // 交易被还原，尝试获取还原原因
                  try {
                    web3.eth.call(
                      {
                        to: this.contractTCashAuctionAddress,
                        data: encoded_tx,
                        from: this.$store.getters.metaMaskObj.account
                      },
                      receipt.blockNumber
                    ).catch(revertError => {
                      // 解析还原原因
                      console.error("Revert Reason:", revertError);
                      const revertReason = this.decodeRevertReason(revertError.message || revertError);
                      this.$message.error(`Transaction reverted: ${revertReason}`);
                    });
                  } catch (callError) {
                    console.error("Error getting revert reason:", callError);
                  }
                }
              })
              .catch(receiptError => {
                console.error("Error getting transaction receipt:", receiptError);
              });
          }

          this.$message.error(errorMessage);
          btn.closeLoad();
        });
    },
    isOver(overtime) {
      return new Date(overtime).getTime() <= new Date().getTime();
    },
    // 添加解码还原原因的方法
    decodeRevertReason(revertMessage) {
      try {
        // 尝试从错误消息中提取还原原因
        // 格式通常是 "execution reverted: <reason>"
        const revertPrefix = "execution reverted:";
        const jsonRpcPrefix = "Internal JSON-RPC error.";

        if (typeof revertMessage === 'string') {
          if (revertMessage.includes(revertPrefix)) {
            return revertMessage.substring(revertMessage.indexOf(revertPrefix) + revertPrefix.length).trim();
          } else if (revertMessage.includes(jsonRpcPrefix)) {
            // 处理JSON-RPC错误格式
            try {
              const jsonStart = revertMessage.indexOf('{');
              if (jsonStart !== -1) {
                const jsonPart = revertMessage.substring(jsonStart);
                const errorObj = JSON.parse(jsonPart);
                if (errorObj.message && errorObj.message.includes(revertPrefix)) {
                  return errorObj.message.substring(errorObj.message.indexOf(revertPrefix) + revertPrefix.length).trim();
                }
                return errorObj.message || "Unknown error";
              }
            } catch (e) {
              console.error("Error parsing JSON-RPC error:", e);
            }
          }
        }
      } catch (e) {
        console.error("Error decoding revert reason:", e);
      }

      return "Unknown reason";
    },

    // 根据交易哈希获取交易失败原因
    async getTransactionErrorByHash(txHash) {
      try {
        // 获取交易信息
        const tx = await web3.eth.getTransaction(txHash);
        if (!tx) {
          console.error("Transaction not found");
          return "Transaction not found";
        }

        // 获取交易回执
        const receipt = await web3.eth.getTransactionReceipt(txHash);
        if (!receipt) {
          console.error("Transaction receipt not found");
          return "Transaction receipt not found";
        }

        console.log("Transaction:", tx);
        console.log("Receipt:", receipt);

        // 如果交易成功，则返回
        if (receipt.status) {
          return "Transaction succeeded";
        }

        // 如果交易失败，尝试获取失败原因
        try {
          // 重新执行交易以获取还原原因
          await web3.eth.call(
            {
              to: receipt.to,
              from: receipt.from,
              data: tx.input,
              value: tx.value,
              gas: tx.gas,
              gasPrice: tx.gasPrice
            },
            receipt.blockNumber
          );
          // 如果上面的调用没有抛出异常，则返回
          return "Unknown error (call succeeded)";
        } catch (callError) {
          console.error("Revert Reason:", callError);
          const revertReason = this.decodeRevertReason(callError.message || callError);
          return `Transaction reverted: ${revertReason}`;
        }
      } catch (error) {
        console.error("Error getting transaction error:", error);
        return "Error getting transaction details: " + (error.message || error);
      }
    },

    // 测试方法 - 可以用于界面上的按钮
    async checkTransaction() {
      const txHash = prompt("请输入要检查的交易哈希");
      if (!txHash) return;

      try {
        const btn = this.$loading.show();
        const errorReason = await this.getTransactionErrorByHash(txHash);
        this.$message.info(errorReason);
        console.log("Transaction error reason:", errorReason);
      } catch (error) {
        console.error("Check transaction error:", error);
        this.$message.error("Check failed: " + (error.message || error));
      } finally {
        this.$loading.hide();
      }
    }
  },
  created() {
    // 添加全局方法，方便在控制台调试
    // if (process.env.NODE_ENV === 'development') {
    //   window.checkTxError = async (txHash) => {
    //     if (!txHash) {
    //       console.error("需要提供交易哈希");
    //       return;
    //     }
    //     try {
    //       const errorReason = await this.getTransactionErrorByHash(txHash);
    //       console.log("交易错误原因:", errorReason);
    //       return errorReason;
    //     } catch (error) {
    //       console.error("检查交易失败:", error);
    //     }
    //   };

    //   // 可以直接检查你提供的交易哈希
    //   const testTxHash = "0xf883987ddaceb20e451459e57410c853b40ba5792598b5409f8bc5988e97abe9";
    //   setTimeout(() => {
    //     console.log("自动检查交易:", testTxHash);
    //     window.checkTxError(testTxHash);
    //   }, 2000);
    // }
  }
};
</script>
<style scoped lang="scss">
.my-header {
  font-size: 0.28rem;
  font-weight: 600;
  color: #1f1f1f;
  text-align: left;
  width: 100%;
}

.unit {
  font-size: 0.18rem;
  font-weight: 400;
  color: #929dad;
  margin-left: 0.04rem;
}

.big-num {
  font-size: 0.28rem;
  font-family: Roboto-Medium, Roboto;
  font-weight: 500;
  color: #1f1f1f;
}

.status {
  font-size: 0.18rem;
  font-weight: 400;
  color: #FFFFFF;
  padding: 0.08rem 0.16rem 0.08rem 0.1rem;
  margin: 0 0 0.16rem 0.3rem;

  &.status-ing {
    background: url("../../../../../assets/image/placeBid/ing.png")no-repeat;
    background-size: 100% 100%;

  }

  &.status-over {
    background: url("../../../../../assets/image/placeBid/over.png")no-repeat;
    background-size: 100% 100%;
  }
}
</style>

<style>
/* 确保对话框标题区域有足够的高度 */
.extract-dialog .el-dialog__header {
  padding: 20px;
}
</style>
